// extracted by mini-css-extract-plugin
export var alignDiscLeft = "p_qw d_fn d_bF d_dt";
export var alignLeft = "p_pK d_fn d_bF d_dt";
export var alignDiscCenter = "p_qx d_fp d_bC d_dv";
export var alignCenter = "p_bN d_fp d_bC d_dv";
export var alignDiscRight = "p_qy d_fq d_bG d_dw";
export var alignRight = "p_pL d_fq d_bG d_dw";
export var footerContainer = "p_qz d_dV d_bV";
export var footerContainerFull = "p_qB d_dS d_bV";
export var footerHeader = "p_kd d_kd";
export var footerTextWrapper = "p_qC d_v";
export var footerDisclaimerWrapper = "p_kl d_kl d_cj";
export var badgeWrapper = "p_qD d_v d_by d_bN d_bD d_bH";
export var footerDisclaimerRight = "p_qF undefined";
export var footerDisclaimerLeft = "p_qG undefined";
export var verticalTop = "p_qH d_by d_bH d_bM d_bK";
export var firstWide = "p_qJ";
export var disclaimer = "p_qK d_by d_bH";
export var socialDisclaimer = "p_qL";
export var left = "p_qM";
export var wide = "p_qN d_cx";
export var right = "p_qP d_bJ";
export var line = "p_fj d_fk d_ct";
export var badgeDisclaimer = "p_qQ d_bB d_bN d_bH";
export var badgeContainer = "p_qR d_by d_bG d_bN";
export var badge = "p_qS";
export var padding = "p_qT d_c6";
export var end = "p_qV d_bG";
export var linkWrapper = "p_qW d_dz";
export var link = "p_mB d_dz";
export var colWrapper = "p_qX d_cw";
export var consent = "p_f d_f d_bB d_bN";
export var media = "p_qY d_bw d_dx";
export var itemRight = "p_qZ";
export var itemLeft = "p_q0";
export var itemCenter = "p_q1";
export var exceptionWeight = "p_q2 w_sb";